import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileUpload } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import { useDispatch } from 'react-redux';
import Spinner from '../../components/Spinner';
import { uploadHpcMcc } from '../../store/modules/newUser/actions';
import './TransferHpcMcc.scss';

const TransferHpcMcc = () => {
  const [isUploadLoading, setIsUploadLoading] = useState(false);
  const dispatch = useDispatch();

  const handleUploadExcelFile = async (type) => {
    try {
      const { value: file } = await Swal.fire({
        icon: 'info',
        title: 'Upload File',
        input: 'file',
        showCancelButton: true,
        confirmButtonColor: 'green',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Upload',
        html: `
      <div>
        <p>To download a sample Excel format, click the link below.</p>
        <a href="https://heritage-vet-plus-server-buckets.s3.ap-south-1.amazonaws.com/images/assets/Transfer-HPC-or-MCC.xlsx">Download</a>
      </div>
    `,
        inputAttributes: {
          accept: '.xls, .xlsx, .csv',
          'aria-label': 'Upload your file',
        },
        // eslint-disable-next-line consistent-return
        inputValidator: (value) => {
          if (!value) {
            return 'You need to choose a file';
          }
        },
      });

      if (file) {
        setIsUploadLoading(true);
        const fileSize = file.size;
        const maxFileSize = 50 * 1024 * 1024; // 50MB limit
        if (fileSize > maxFileSize) {
          throw new Error(`File size exceeds ${maxFileSize / (1024 * 1024)}MB limit`);
        }
        if (!['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'].includes(file.type)) {
          throw new Error('Invalid file format');
        }

        const reader = new FileReader();
        reader.onload = () => {
          let timerInterval;
          const fileSizeInMb = fileSize / (1024 * 1024);
          const uploadTimeInSeconds = Math.ceil(fileSizeInMb); // 1 second per 1MB
          Swal.fire({
            icon: 'success',
            toast: true,
            title: 'Uploading your data!',
            html: `Uploading ${fileSizeInMb.toFixed(2)} MB file in <b>${uploadTimeInSeconds} seconds</b>.`,
            timer: uploadTimeInSeconds * 1000,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
              const b = Swal.getHtmlContainer().querySelector('b');
              timerInterval = setInterval(() => {
                b.textContent = Swal.getTimerLeft();
              }, 100);
            },
            willClose: () => {
              clearInterval(timerInterval);
            },
          });
        };
        reader.readAsDataURL(file);
        const formData = new FormData();
        formData.append('file', file);
        let params = '';
        if (type === 'HPC') {
          params = '?hpc=true';
        } else {
          params = '?mcc=true';
        }
        // dispatch(uploadHpcMcc(formData, handleRefresh))
        dispatch(uploadHpcMcc(formData, null, params))
          .finally(() => {
            setIsUploadLoading(false);
          });
      } else {
        throw new Error('No file was uploaded.');
      }
    } catch (error) {
      setIsUploadLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        toast: true,
        text: error.message,
      });
    }
  };

  return (
    <div className="col-12">
      <div className="heading">
        <p className="heading__title">
          Transfer HPC Or Transfer MCC
        </p>
      </div>
      <div className="form-bg">
        <div className="buttons">
          <button
            type="button"
            className="button danger"
            onClick={() => handleUploadExcelFile('HPC')}
          >
            {isUploadLoading ? (
              <>
                <Spinner />
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faFileUpload} className="button__icon" />
                Transfer HPC
              </>
            )}
          </button>
          <button
            type="button"
            className="button primary"
            onClick={() => handleUploadExcelFile('MCC')}
          >
            {isUploadLoading ? (
              <>
                <Spinner />
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faFileUpload} className="button__icon" />
                Transfer MCC
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TransferHpcMcc;
